import { css } from '@emotion/core'

export const cardStyle = css`
  .ui.card& {
    box-shadow: none;
  }
  width: 294px;
  display: inline-block;
  vertical-align: top;
`
